import { VariantEvaluationViewParameters } from './VariantEvaluationViewParameters.model';
import { EvaluationFrontendParameter } from './EvaluationFrontendParameter.model';

export class VariantEvaluationFrontendParameter extends EvaluationFrontendParameter {
    variantAndDoorList: VariantEvaluationViewParameters[];
}